import { inject, Injectable } from '@angular/core';
import { StringUtils } from '@festo-ax/smartenance-shared-ui';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationStore } from 'app/state-management/application/application.store';

@Injectable({ providedIn: 'root' })
export class StoreHelperService {
  private readonly appStore: ApplicationStore = inject(ApplicationStore);
  private readonly translateService: TranslateService = inject(TranslateService);

  showErrorSnack(defaultKey: string, error?: unknown): void {
    const errorDefault: string = this.translateService.instant(defaultKey);
    const text: string = StringUtils.isString(error) ? error : errorDefault;

    this.appStore.showSnack({ text, type: 'error' });
  }

  showSuccessSnack(key: string): void {
    const text: string = this.translateService.instant(key);

    this.appStore.showSnack({ text });
  }
}
